<template>
  <div class="panel"
       :style="panelStyle"
       @click="click">

    <div class="border-bottom px-2 py-3">
      <h5 class="text-center text-uppercase">{{$t('message.campaigns.message.changeInteraction')}}</h5>

      <span class="text-md text-uppercase">
        <app-tab-selector :value="selectedTab"
                          :data-tabs="tabs"
                          @input="selectPendingInteraction"></app-tab-selector>
      </span>
    </div>

    <app-banner v-if="isBanner"
                :data-interaction="interaction"
                @add-option="addOption"
                @update-option="updateOption"
                @remove-option="removeOption"
                @input="update"
                @reload="reloadOptions"></app-banner>

    <app-survey v-if="isSurvey"
                :data-interaction="interaction"
                :selectedType="interaction.tipo"
                @update="update"
                @add-option="addOption"
                @update-option="updateOption"
                @remove-option="removeOption"
                @selectType="(type) => pendingInteractionType = type"
                @reload="reloadOptions" />

    <app-cupom v-if="isCupom"
               :data-interaction="interaction"
               @update-option="updateOption">
    </app-cupom>

    <app-video v-if="isVideo"
               :data-interaction="interaction"
               :video="isVideo"
               @update-option="updateOption"
               @input="update">
    </app-video>

    <app-panel-ads v-if="isAds"
                  :data-interaction="interaction"
                  :selectedType="interaction.tipo"
                  @update="update"
                  @add-option="addOption"
                  @update-option="updateOption"
                  @remove-option="removeOption"
                  @reload="reloadOptions"
                  @selectType="(type) => pendingInteractionType = type"></app-panel-ads>

    <template v-if="showFooter && !isVideo">
      <div class="footer  border-bottom">
        <h6 class="text-uppercase interaction-background-title">
          FUNDO DA INTERAÇÃO
        </h6>

        <div class="interaction-background-actions">

          <background-color-editor v-show="!backgroundMobile && backgroundType === 'COLOR' && !isBanner"
                                   :data-interaction="interactionStored"
                                   label="Fundo da interação"
                                   :isGradient="isGradientStored"
                                   @selectedFalse="isColorPickerOpen = false"
                                   ref="bgColorEditor"></background-color-editor>

          <div v-show="!backgroundMobile && backgroundType === 'COLOR' && !isBanner"
               class="full-width">
            <v-checkbox class="checkbox-container" v-model="isGradientStored"></v-checkbox>
            <label>{{$t('message.campaigns.message.enableGradientColor')}}</label>
          </div>

          <button v-if="!backgroundMobile && !backgroundType && !isBanner"
                  class="btn-background btn-primary btn btn-sm btn-extra-round"
                  @click="setColorToNormal">
            {{$t('message.campaigns.message.selectBackgroundColor')}}
          </button>

          <template v-if="!isGooglePublisherTag">
            <app-file-uploader v-if="backgroundMobile"
                              data-location="PANEL"
                              :data-id="interaction.id"
                              :data-parent-id="interaction.campanhaId"
                              :label="$t('message.campaigns.message.selectImagePhone')"></app-file-uploader>

            <app-file-uploader v-if="backgroundMobile"
                              data-location="PANEL"
                              :data-id="interaction.id"
                              :data-parent-id="interaction.campanhaId"
                              :is-mobile="false"
                              :label="$t('message.campaigns.message.selectImageComputer')"></app-file-uploader>

            <app-file-uploader v-if="!backgroundMobile"
                              data-location="PANEL"
                              isPrimaryButton
                              :data-id="interaction.id"
                              :data-parent-id="interaction.campanhaId"
                              :label="$t('message.campaigns.message.selectImage')"></app-file-uploader>

            <button v-if="backgroundMobile && !isBanner"
                    class="btn btn-secondary btn-sm btn-extra-round no-padding"
                    @click="removeImgsAndSetBackgroundColor">
                    {{$t('message.campaigns.message.removeImagesAndSelectColor')}}
            </button>
          </template>
        </div>
      </div>

      <div class="interaction-helpers border-bottom">
          <side-panel-banner-copy-value 
            v-if="isBanner"
            :interaction="interaction" 
            @input="update"></side-panel-banner-copy-value>

          <interaction-minimum-time
            v-if="isBanner"
            :interaction="interaction"
            @input="update"
          ></interaction-minimum-time>

          <integration-option :interaction-data="interaction"
                              @change="setIntegration" />
      </div>
    </template>

    <app-confirmation-modal :value="!!pendingInteractionType"
                            confirm-label="Alterar"
                            @confirm="confirmInteractionTypeUpdate"
                            @cancel="pendingInteractionType = null">

      <span slot="heading">
        {{$t('message.campaigns.message.changeInteractionType')}}
      </span>

      <span>
        {{$t('message.campaigns.message.changeInteractionTypeConfirmation')}} <span class="text-bold">{{$t('message.campaigns.message.buttons')}}</span>,
        <span class="text-bold">{{$t('message.campaigns.message.colors')}}</span> {{$t('message.campaigns.message.and')}} <span class="text-bold">{{$t('message.campaigns.message.texts')}}</span> {{$t('message.campaigns.message.changeInteractionTypeConfirmation2')}}
      </span>

    </app-confirmation-modal>

    <app-confirmation-modal :value="showingVideoWarningModal"
                            confirm-label="Ok, entendi"
                            is-only-one-button
                            @confirm="acceptVideoWarning"
                            >
      <span slot="heading">
        {{$t('message.campaigns.message.attention')}}
      </span>
      <span v-html="$t('message.campaigns.message.videoWarning')"></span>
    </app-confirmation-modal>

  </div>
</template>

<script>
import SidePanelBannerCopyValue from "./components/banner/SidePanelBannerCopyValue.vue";
import AppCupom from "./components/Cupom.vue";
import AppSurvey from "./components/Survey.vue";
import IntegrationOption from "./components/IntegrationOption";
import AppBanner from "./components/Banner";
import AppTabSelector from "@components/TabSelector";
import AppFileUploader from "@components/FileUploader";
import AppConfirmationModal from "@components/ConfirmationModal";
import EventBus from "@packages/event-bus";
import _ from "lodash";
import BackgroundColorEditor from "@views/interactions/components/SidePanel/components/BackgroundColorEditor"
import AppVideo from "./components/Video.vue"
import InteractionMinimumTime from "./components/InteractionMinimumTime.vue";
import AppPanelAds from "./components/ads/SidePanelAds.vue";

export default {
  components: {
    AppBanner,
    AppTabSelector,
    AppFileUploader,
    AppConfirmationModal,
    AppSurvey,
    AppCupom,
    IntegrationOption,
    BackgroundColorEditor,
    InteractionMinimumTime,
    AppVideo,
    AppPanelAds,
    SidePanelBannerCopyValue
  },

  data() {
    return {
      pendingInteractionType: null,
      selectedTab: undefined,
      backgroundColorInteraction: undefined,
      isColorPickerOpen: false,
      panelHeight: undefined,
      backgroundColorObjMocked: {
        active: true,
        color: {a: 1, b: 248, g: 242, r: 240},
        isGradient: false
      },
      showingVideoWarningModal: false
    };
  },

  created() {
    const isPesquisaType = this.dataInteraction.tipo.includes("PESQUISA") || this.dataInteraction.tipo === "OPEN_FIELD";
    const isAdsType = this.dataInteraction.tipo === 'GOOGLE_PUBLISHER_TAG' || this.dataInteraction.tipo === 'VAST'; 

    this.selectedTab = isPesquisaType ? "PESQUISA" : isAdsType ? 'ADS' : this.dataInteraction.tipo;

  },

  mounted() {
    const selectedInteraction = this.$store.state.interactions.list.find(interaction => interaction.id === this.interaction.id)
    this.backgroundColorInteraction = selectedInteraction.estilo.backgroundColorInteraction ?
                                      selectedInteraction.estilo.backgroundColorInteraction.color :
                                      this.backgroundColorObjMocked.color

    EventBus.$on("HANDLE_HEIGHT", this.handlePanelHeight);
  },

  beforeDestroy() {
    EventBus.$off("HANDLE_HEIGHT", this.handlePanelHeight);
  },

  computed: {
    canCreateAdInteraction() {
      return !!this.$store.state.users.user.permissions.find((x) => x === "USE_ADVERTISEMENT");
    },
    panelStyle() {
      return this.isColorPickerOpen ? {"height": `${this.panelHeight}`} : ""
    },
    showFooter() {
      if(this.selectedTab === 'ADS' && this.dataInteraction.tipo !== 'GOOGLE_PUBLISHER_TAG') {
        return false
      }

      if (this.selectedTab !== "PESQUISA") {
        return true;
      }

      return (
        this.interaction.tipo === "PESQUISA_NPS" ||
        this.interaction.tipo === "PESQUISA_OBJETIVA" ||
        this.interaction.tipo === "OPEN_FIELD"
      );
    },
    interaction() {
      return this.dataInteraction;
    },

    isBanner() {
      return this.selectedTab === "BANNER";
    },

    isSurvey() {
      return this.selectedTab === "PESQUISA";
    },

    isCupom() {
      return this.selectedTab === "CODIGO_PROMOCIONAL";
    },

    isVideo() {
      return this.selectedTab === "VIDEO";
    },

    isGooglePublisherTag() {
      return this.dataInteraction.tipo === "GOOGLE_PUBLISHER_TAG";
    },

    isAds() {
      return this.selectedTab === "ADS";
    },

    tabs() {
      return this.dataInteraction.tipo === "CODIGO_PROMOCIONAL"
      ? [
        { value: "BANNER", label: this.$t("message.campaigns.message.banner") },
        { value: "PESQUISA", label: this.$t("message.campaigns.message.poll") },
        {
          value: "VIDEO",
          label: this.$t("message.campaigns.message.video"),
        },
        {
          value: "CODIGO_PROMOCIONAL",
          label: this.$t("message.campaigns.message.coupon"),
        },
      ]
      :[
        { value: "BANNER", label: this.$t("message.campaigns.message.banner") },
        { value: "PESQUISA", label: this.$t("message.campaigns.message.poll") },
        {
          value: "VIDEO",
          label: this.$t("message.campaigns.message.video"),
        },
        {
          value: "ADS",
          label: 'Anúncio',
          disabled: !this.canCreateAdInteraction
        },
      ];
    },

    backgroundMobile() {
      const selectedInteraction = this.$store.state.interactions.list.find(interaction => interaction.id === this.interaction.id)
      return selectedInteraction.mediaMobile
    },

    backgroundColorObj() {
      const selectedInteraction = this.$store.state.interactions.list.find(interaction => interaction.id === this.interaction.id)
      return selectedInteraction.estilo.backgroundColorInteraction ? selectedInteraction.estilo.backgroundColorInteraction : this.backgroundColorObjMocked
    },

    isGradientStored: {
      get() {
        return this.backgroundColorObj ? this.backgroundColorObj.isGradient : this.backgroundColorObjMocked.isGradient

      },
      set(val) {
        if(val) {
          this.setColorToGradient()
        } else {
          this.setColorToNormal()
        }
      }
    },

    backgroundColorStored() {
      return this.backgroundColorObj ? this.backgroundColorObj.color : this.backgroundColorObjMocked.color
    },

    interactionStored() {
      return this.$store.state.interactions.list.find(interaction => interaction.id === this.interaction.id)
    },

    numberOfOptions() {
      return this.interactionStored.opcoes.length
    },

    backgroundType() {
      const selectedInteraction = this.$store.state.interactions.list.find(interaction => interaction.id === this.interaction.id)
      return selectedInteraction.estilo.backgroundType
    },
  },

  watch: {
    backgroundColorStored(val) {
      this.backgroundColorInteraction = val
    },
    panelHeight(val) {
      const height = val.split('px')[0]
      if(Number(height) > 940 ) {
          document.querySelector('.intercom-lightweight-app').style.opacity = '0'
          document.querySelector('.intercom-lightweight-app').style.pointerEvents  = 'none'
      }
    },
    isColorPickerOpen(val) {
      if(!val) {
        this.panelHeight = '0px'
          document.querySelector('.intercom-lightweight-app').style.opacity = '1'
          document.querySelector('.intercom-lightweight-app').style.pointerEvents  = 'auto'
      }
    },
  },

  methods: {
    handlePanelHeight() {
      const interactionType = this.interactionStored.tipo
      this.isColorPickerOpen = true
      if(!this.isColorPickerOpen) {
        this.panelHeight = 0
      }
      if(interactionType === "BANNER") {
        this.numberOfOptions === 1 ? this.panelHeight = "770px" : this.panelHeight = "955px"
      }
      if(interactionType === "CODIGO_PROMOCIONAL") {
        this.panelHeight = "710px"
      }
      if(interactionType === "PESQUISA_NPS") {
        this.panelHeight = "880px"
      }
      if(interactionType === "PESQUISA_OBJETIVA") {
        this.numberOfOptions === 2 ? this.panelHeight = "940px" : this.panelHeight = "1200px"
      }
    },

    setIntegration(val) {
      this.dataInteraction.hookId = val;
    },

    reloadOptions() {
      const payload = {
        interactionId: this.interaction.id,
        advertisingId: this.interaction.campanhaId,
      };

      this.loadOptions(payload);
    },

    selectPendingInteraction(event) {
      if (
        (event === "BANNER" || event === "CODIGO_PROMOCIONAL" || event === "VIDEO") &&
        event !== this.interaction.tipo
      ) {
        this.pendingInteractionType = event;
      } else {
        this.selectedTab = event;
      }
    },

    acceptVideoWarning() {
      this.userHasSeenVideoWarning = true;
      this.showingVideoWarningModal = false;
      this.confirmInteractionTypeUpdate();
    },

    async confirmInteractionTypeUpdate() {
      if(this.pendingInteractionType === "VIDEO" && !this.userHasSeenVideoWarning) {
        return this.showingVideoWarningModal = true
      }

      const configObj = this.pendingInteractionType === "VIDEO"
      ? {
        tipo: this.pendingInteractionType,
        mediaMobile: null,
        mediaDesktop: null,
        minimumTime: 10,
        isCloudflareVideo: false
      }
      : {
        tipo: this.pendingInteractionType
      }
      if(this.interaction.tipo === 'VIDEO') {
        configObj.mediaMobile = null;
        configObj.mediaDesktop = null
      }
      await this.update(configObj);
      this.interaction.tipo = this.pendingInteractionType;

      if(this.pendingInteractionType === "VIDEO") {
        this.interaction.mediaMobile = null
        this.interaction.mediaDesktop = null
        this.userHasSeenVideoWarning = false;
      }

      if (
        this.pendingInteractionType === "BANNER" ||
        this.pendingInteractionType === "CODIGO_PROMOCIONAL" ||
        this.pendingInteractionType === "VIDEO"
      ) {
        this.selectedTab = this.pendingInteractionType;
      }
      this.pendingInteractionType = null;

      if(this.selectedTab === "BANNER" || this.dataInteraction.tipo === 'GOOGLE_PUBLISHER_TAG') {
        setTimeout(() => this.$refs.bgColorEditor.set({
        color: {r: 240, g: 242, b: 248, a: 1},
        attr: 'backgroundColorInteraction'}), 600)

      }
    },

    update(data) {
      const payload = {
        interactionId: this.interaction.id,
        advertisingId: this.interaction.campanhaId,
        data,
      };
      this.$api.interactions
        .update(payload)
        .then(() => this.$loader.interactions.load(this.interaction.campanhaId))
        .then(() => this.loadOptions(payload));
    },

    addOption() {
      const payload = {
        interactionId: this.interaction.id,
        advertisingId: this.interaction.campanhaId,
      };
      this.$api.interactions.options
        .create(payload)
        .then(() => this.loadOptions(payload));
    },

    removeOption(option) {
      const payload = {
        optionId: option.id,
        interactionId: this.interaction.id,
        advertisingId: this.interaction.campanhaId,
      };
      this.$api.interactions.options
        .remove(payload)
        .then(() => this.loadOptions(payload));
    },

    updateOption({ option, data }) {
      _.forEach(data, (value, key) => {
        option[key] = value;
      });
      this.$api.interactions.options.edit({
        interactionId: this.interaction.id,
        advertisingId: this.interaction.campanhaId,
        optionId: option.id,
        data,
      });
    },

    loadOptions({ interactionId, advertisingId }) {
      this.$loader.interactions.options({
        interactionId,
        advertisingId,
      });
    },

    click(evt) {
      this.isColorPickerOpen = false
      EventBus.$emit("SIDE_PANEL_CLICK", evt);
      evt.stopPropagation();
    },

    async removeImgsAndSetBackgroundColor() {
      try {
        await this.$api.interactions.removeBackground({
          advertisingId: this.interaction.campanhaId,
          interactionId: this.interaction.id,
          isMobile: true
        })
        await this.$loader.interactions.load(this.interaction.campanhaId)
        this.setColorToNormal()
      } catch (error) {
        console.log(error)
      }
    },

    setColorToGradient() {
      const newColor = this.backgroundColorInteraction
      this.$refs.bgColorEditor.set({
        color: `linear-gradient(0deg, rgba(${newColor.r}, ${newColor.g}, ${newColor.b}, ${newColor.a}) 0%, rgba(${newColor.r}, ${newColor.g}, ${newColor.b}, ${newColor.a}) 100%)`,
        attr: 'backgroundColorInteraction'})
    },
    setColorToNormal() {
      this.$refs.bgColorEditor.set({
        color: {r: 255, g: 255, b: 255, a: 1},
        attr: 'backgroundColorInteraction'})
    }
  },

  props: {
    dataInteraction: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";
@import "mixins/panel-body";

.panel {
  position: fixed;
  top: 50px;
  right: 10px;
  width: 300px;
  border: 1px solid $grey-1;
  border-radius: 25px;
  background-color: $white;
  box-shadow: $shadow-2;
  z-index: 2;

  clip: rect(auto, auto, auto, -200px);
  overflow-y: auto;

  .panel-body {
    overflow-y: visible;
  }
  max-height: calc(100vh - 60px);


  .footer {
    padding: 15px;

    .interaction-background-title {
      margin-bottom: 15px;
    }
    .interaction-background-actions {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;

      .full-width {
        display: flex;
        justify-content: flex-start;
        padding-left: 4px;
        align-items: center;

        .checkbox-container {
          flex: none;
          padding-top: 0;
          margin-top: 0;
          height: 25px;
        }

        label {
          align-self: flex-start;
          margin-top: 4px;
        }
      }

      .btn {
        font-size: 14px;
      }

      input[type="checkbox"] {
        cursor: pointer;
      }


      .no-padding {
        padding-left: 10px ;
        padding-right: 10px ;
      }
    }
  }

  .panel-submit {
    padding: 15px;
    display: flex;
    justify-content: center;
  }
}

.interaction-helpers {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 16px;
}

::-webkit-scrollbar {
  width: 5px;
}
</style>
